export enum TcListSortType {
  Client = 'client',
  Server = 'server',
  Disabled = 'disabled',
}
